import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ColorPickerIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M19.001 9.66165L22.3838 6.75445C23.8868 5.42375 23.9369 2.90265 22.4854 1.51465C21.0974 0.0631547 18.5763 0.113255 17.2456 1.61625L14.3384 4.99905C13.5108 4.62696 12.5024 4.78035 11.8233 5.45806C11.0168 6.23206 10.9445 7.59396 11.6635 8.44686L3.5772 16.5332C3.5292 16.5939 3.4816 16.654 3.4337 16.7146L2.3487 18.4702L1.4102 19.4087C0.536601 20.2444 0.535801 21.7534 1.4097 22.5903C2.2466 23.4642 3.7556 23.4634 4.5913 22.5898L5.5298 21.6513L7.2854 20.5663C7.3461 20.5183 7.4062 20.4707 7.4668 20.4228L15.5531 12.3365C16.4061 13.0555 17.768 12.9832 18.5419 12.1767C19.2196 11.4975 19.3731 10.4893 19.001 9.66165ZM6.4463 19.3224L4.6907 20.4074C4.63 20.4554 4.5699 20.503 4.5093 20.551L3.5299 21.5304C3.2509 21.8217 2.7506 21.8216 2.471 21.5293C2.1787 21.2497 2.1786 20.7493 2.4699 20.4704L3.4493 19.491C3.4973 19.4304 3.5449 19.3703 3.5929 19.3096L4.6779 17.554L12.707 9.52485L14.4755 11.2934L6.4463 19.3224ZM16.4199 11.1168L12.8832 7.58005C12.6 7.29685 12.6005 6.80175 12.8827 6.52045C13.1757 6.22745 13.6517 6.22645 13.9433 6.51955C14.2366 6.82595 14.774 6.80665 15.0438 6.47945L18.3646 2.61515C19.1277 1.75565 20.6252 1.72885 21.4247 2.57515C22.271 3.37465 22.2442 4.87206 21.3847 5.63525L17.5204 8.95605C17.1932 9.22596 17.174 9.76336 17.4803 10.0566C17.7733 10.3481 17.7723 10.8242 17.4794 11.1172C17.1981 11.3994 16.7031 11.4 16.4199 11.1168Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ColorPickerIcon.displayName = 'ColorPickerIcon';
